import script from "./dataField.vue?vue&type=script&setup=true&lang=ts"
export * from "./dataField.vue?vue&type=script&setup=true&lang=ts"

import "./dataField.vue?vue&type=style&index=0&id=0c6743c4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c6743c4"]])

export default __exports__